import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'src/app/app-config';

@Component({
  selector: 'app-sco-confidentiality-agreement',
  templateUrl: './sco-confidentiality-agreement.component.html'
  
})
export class ScoConfidentialityAgreementComponent implements OnInit {

  constructor(private config: AppConfig) { }
  IsPortal = this.config.IsPortal;
  documentPath;

  ngOnInit() {
    if (!this.IsPortal)
      this.documentPath = this.config.SCOCADocumentURL
    else
      this.documentPath = this.config.SCOCADocumentURLPortal
  }


}
